export const alertConstants = {
  SUCCESS: "ALERT_SUCCESS",
  ERROR: "ALERT_ERROR",
  CLEAR: "ALERT_CLEAR",
};

export const AUTO_DISMISS_ALERT_MS = 3000;

export const Z_INDEX_MODAL_PORTAL_LAYER = 10040;

export const Z_INDEX_MODAL_OVERLAY = 10050;

export const APP_MODAL_PORTAL_ID = "app-modal-portal";

export const Z_INDEX_APP_NOTIFICATIONS_LAYER = 100600;
